import axios from 'axios';
import base64 from 'base-64';

const API_KEY = "EPaHrl0lSnXyMKxlM6liYzoravA1cIj2"

const instance = axios.create({
//    baseURL: BASE_URL,
});

function getauth() {
    let userId = localStorage.Cookies ? JSON.parse(localStorage.Cookies).userId : null;
    var authorization_value = null;
    if (userId)
        authorization_value = "Basic " + base64.encode(encodePassword(userId) + ":");
    return authorization_value;
}

function setHeaders(fileFlag = 0) {
    let headers = {
        Authorization: getauth(),
    }
    if (fileFlag === 1) {
        headers['Content-Type'] = 'multipart/form-data';
    } else {
        headers['Content-Type'] = 'application/json';
    }
    return headers;
}

const ErrorMessages = {
    400: 'There was Some Problem, while processing your Request', // The server could not understand the request due to invalid syntax.
    401: 'Unauthorized, You are not Allowed',
    403: 'Sorry, You are not allowed for this Action', //Forbidden
    404: 'The server can not find the requested resource', //Not Found
    405: 'API Route Method Not Allowed',
    500: 'Server Error, please try again later',
    503: 'Service Unavailable',
    504: 'Server Error, please try again later',
    request:
      'There is Some Problem With Our Servers, Please Try again Later',
    other:
      'There was some Problem with your Request, Please Try again Later',
}

export default function CallAPI(method, url, data = null, params = null, fileFlag = 0,callback, authData=localStorage.Cookies, responseType=null) {
    let userId = localStorage.Cookies ? JSON.parse(localStorage.Cookies).userId : (authData ? authData.userId : null);
    var authorization_value = null;
    var systemauth = null;
    let lowerMethod = method.toLowerCase()
    let postMethod = 'post';

    let loginSessionId = url == '/app/oidc/token' ? encodePassword(data['companyName']) : null;

    // Encode Post request body
    if(lowerMethod == postMethod && fileFlag !== 1) {
        data = encodePostBody(data)
    }     

    if(params !== null && params !== undefined){
        systemauth = (params.auth !== undefined && params.auth !== null) ? params.auth : null;
    }

    // Encoding authorization token for randomization
    // if (userId && systemauth == null ){
        authorization_value = "Basic " + base64.encode(encodePassword(userId) + ":");
    // }
    if(systemauth == "system"){
        // authorization_value = "Basic " + base64.encode(base64.encode(encodePassword(API_KEY)) + ":");
        authorization_value = "Basic " + base64.encode(encodePassword(API_KEY) + ":");
        // authorization_value = "Basic " + base64.encode(API_KEY + ":");
    }

    let sessionId = authData ? encodePassword(authData.sessionId) : loginSessionId    

    let contentType = 'application/json';
    let onUploadProgress = null;
    if (fileFlag === 1) {
        contentType = 'multipart/form-data';
        onUploadProgress = function(progressEvent) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            if(percentCompleted==100){
                jQuery(".addRow").html(`<span class='spinner-border spinner-border-sm mg-x-5' role='status' aria-hidden="true"></span> Finializing...`);
                jQuery("#uploadFile").html(`<span class='spinner-border spinner-border-sm mg-x-5' role='status' aria-hidden="true"></span> Finializing...`);
            }else {
                jQuery(".addRow").html(`<span class='spinner-border spinner-border-sm mg-x-5' role='status' aria-hidden="true"></span>
                <span if="file_loading_percentage">(${percentCompleted} %) </span>
                Loading Data...`);
                jQuery("#uploadFile").html(`<span class='spinner-border spinner-border-sm mg-x-5' role='status' aria-hidden="true"></span>
                <span if="file_loading_percentage">(${percentCompleted} %) </span>
                Loading Data...`);
            }
        }
    }
    instance({
        method: method,
        url: url,
        data: data,
        async: true,
        headers: {
            Authorization: authorization_value,
            'Content-Type': contentType,
            'sessionId': sessionId
        },
        params: params,
        onUploadProgress: onUploadProgress,
        responseType: responseType

    }).then(result => {
        // Decode api response. We will get all the api response encoded
        // if(lowerMethod == postMethod) {
            let response = decodeResponseBody(result['data'])
            response && response['data'] == result['data'] ? callback(result.data) : callback(response)
            // callback(result);
        // } else {
        //     result = decodeResponseBody(result['data'])
        //     callback(result.data);
        // }                
    }).catch(err => {        
        if (err && err.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // client received an error response (5xx, 4xx)
            //errorMessage['information'] = ErrorMessages[err.response.status];
            if (err.request.status == '408') {
                alert("Session Timed Out. Please login again.");
                logoutHandle(true);
            } else if (err.response.status == 500) {
                callback(err.response)
            } else {
                alert(`${err.response.status}: ${ErrorMessages[err.response.status]}`);
            }         
        } else if (err && err.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            //errorMessage['information'] = ErrorMessages[err.request];            
            alert(refineURLData(err.response.data) ? err.response.data : ErrorMessages['request']);
        } else {
            // Something happened in setting up the request that triggered an Error
            //errorMessage['information'] = ErrorMessages[err.message];
            alert(ErrorMessages['other']);
        }
    })
}
